export default __webpack_public_path__ + "static/media/illustration1.e6d94c97.svg";